module.exports = __webpack_public_path__ + "media/images/logo_nav-44fc42bfafaefa0a59c342f1b7c7df9b.png";